var _rect, _rect2, _rect3, _circle, _circle2, _circle3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeanshellLinter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 420",
    role: "img",
    "aria-label": "Terminal output from the BeanShell XML linter",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 420,
    rx: 12,
    fill: "#14141c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 34,
    rx: 12,
    fill: "#2a2a3a"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 600,
    height: 14,
    fill: "#2a2a3a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 17,
    r: 6,
    fill: "#ff5f56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 17,
    r: 6,
    fill: "#ffbd2e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 17,
    r: 6,
    fill: "#27c93f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Consolas, 'Courier New', monospace",
    fontSize: 13,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 66,
    fill: "#8fe0a0"
  }, "$ java -jar beanshell-xml-linter.jar rules/"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 100,
    fill: "#ffd98f"
  }, "demo.xml:5: [WARNING]"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 118,
    fill: "#e6e6f0"
  }, "  [hardcoded-secret]"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 146,
    fill: "#ffd98f"
  }, "demo.xml:6: [WARNING]"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 164,
    fill: "#e6e6f0"
  }, "  [todo-fixme-comment]"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 192,
    fill: "#ffd98f"
  }, "demo.xml:7: [WARNING]"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 210,
    fill: "#e6e6f0"
  }, "  [ldap-injection-risk]"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 238,
    fill: "#ffd98f"
  }, "demo.xml:10: [WARNING]"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 256,
    fill: "#e6e6f0"
  }, "  [empty-catch-block]"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 284,
    fill: "#ff8f8f"
  }, "known-bad.xml:16: [ERROR]"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 302,
    fill: "#e6e6f0"
  }, "  [bsh-syntax-error]"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 340,
    fill: "#c9c7ee"
  }, "1 error(s), 4 warning(s)"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 372,
    fill: "#a9a5ff"
  }, "exit code 1: build fails"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeanshellLinter);
export default __webpack_public_path__ + "static/media/beanshellLinter.f3c407406871a0ae222a1c70327d8ab9.svg";
export { ForwardRef as ReactComponent };